import Decimal from 'decimal.js-light';

/**
 * TypeConverter класс с набором статических методов для упращения конвертации типов
 */
export class TypeConverter {
  public static stringToNumber(
    value: string,
    defaultValue = 0,
    radix = 10
  ): { n: number; ok: boolean } {
    const num = parseInt(value, radix);

    return num ? { n: num, ok: true } : { n: defaultValue, ok: false };
  }

  /**
   * Клонирование простых моделей
   * @param {Object} obj
   * @return {Object}
   */
  public static cloneSimple<T>(obj: T): T {
    const data = JSON.stringify(obj);
    return JSON.parse(data);
  }

  public static numberToMoney(n: number, divider: number, remainderLength = 2): string {
    const num = new Decimal(n);
    return num.dividedBy(Math.pow(10, divider)).toFixed(remainderLength, Decimal.ROUND_DOWN);
  }

  /**
   * @deprecated use numberToMoney
   */
  public static deprecatedNumberToMoney(n: number, d = 2): string {
    return (Math.floor(n) / 100).toFixed(d);
  }

  public static numberToLots(n: number, d = 2): string {
    return (Math.floor(n) / 10000).toFixed(d);
  }

  public static moneyToNumber(n: string | number, multiplier = 2, remainderLength = 0): number {
    if (n === null || n === undefined) {
      return +n;
    }
    let numberString = (typeof n === 'number' ? n.toString() : n)
      .replace(new RegExp(`,([0-9]+)$`, 'g'), '.$1').replace(/[^0-9.-]+/g, '');

    if (isNaN(+numberString)) {
      numberString = numberString.replace(/[^0-9]+/g, '');
    }

    if (!multiplier) {
      return +numberString;
    }

    const num = new Decimal(numberString !== '' ? numberString : 0);
    return +(num.mul(Math.pow(10, multiplier)).toFixed(remainderLength));
  }

  /**
   * @deprecated use moneyToNumber
   */
  public static deprecatedMoneyToNumber(n: string | number, multiplier = 2, keepRemainder = false): number {
    if (n === null || n === undefined) {
      return +n;
    }

    let numberString = (typeof n === 'number' ? n.toString() : n)
      .replace(new RegExp(`,([0-9]+)$`, 'g'), '.$1').replace(/[^0-9.-]+/g, '');

    if (isNaN(+numberString)) {
      numberString = numberString.replace(/[^0-9]+/g, '');
    }

    if (!multiplier) {
      return +n;
    }

    const strLength = numberString.length - 1;
    const dotPosition = numberString.indexOf('.');

    if (dotPosition <= 0) {
      return +(n + '0'.repeat(multiplier));
    }

    const strWithoutDot = numberString.replace('.', '');
    const dotShift = strLength - dotPosition;

    const result = dotShift === multiplier ? strWithoutDot : dotShift > multiplier ?
      strWithoutDot.slice(0, strLength - (dotShift - multiplier)) + '.' + strWithoutDot.slice(strLength - (dotShift - multiplier)) :
      strWithoutDot + '0'.repeat(multiplier - dotShift);

    return +(keepRemainder ? result : result.split('.')[0]);
  }

  public static dateToString(d: Date): string {
    return d.getUTCFullYear() + (d.getUTCMonth() >= 9 ? '' : '0') + (d.getUTCMonth() + 1) + (d.getUTCDate() > 9 ? '' : '0') + d.getUTCDate();
  }

  public static padNumber(num: number, size = 2): string {
    let result = String(num);
    while (result.length < size) {
      result = '0' + result;
    }
    return result;
  }
}
